import * as React from 'react';

export type OnMouseLeaveContextType =
  | ((e: React.MouseEvent<HTMLElement>) => void)
  | undefined;

export const onMouseLeaveContext = React.createContext<OnMouseLeaveContextType>(undefined);
